import { get } from 'lodash'
import HeadersModal from '@/views/components/common/HeadersModal'

export default {
  data: () => ({
    loading: false,
    isHeadersModalActive: false,
    items: [],
    totalItems: 0,
    options: {},
    defaultPaginationItemsPerPageOptions: [5, 10, 15, 20, 30, 50, 100],
    filtersFirstLoaded: false,
  }),
  components: {
    HeadersModal,
  },
  computed: {
    userHeaders() {
      return get(this.user, `preferences.customTableHeaders.${this.tableName}`, [])
    },
    headers() {
      let headers
      if (this.useAlwaysDefaultHeaders) {
        headers = this.defaultHeaders
      } else if (this.userHeaders && this.userHeaders.length) {
        headers = this.userHeaders
      } else {
        headers = this.defaultHeaders
      }

      return headers.filter((item) => {
        return !item.customHidden
      })
    },
  },
  methods: {
    customHeaders() {
      this.isHeadersModalActive = true
    },
    async updateOptions() {
      if (this.filtersFirstLoaded) this.loadItems()
    },
    setFirstPage() {
      this.options.page = 1
    },
    async filterElements(filters) {
      this.$set(this, 'filters', JSON.parse(JSON.stringify(filters)))
      this.setFirstPage()
      await this.loadItems()
      if (!this.filtersFirstLoaded) this.filtersFirstLoaded = true
    },
    getTablePaginationOptions(options) {
      const page = options.page
      const limit = options.itemsPerPage
      const sort = {}
      const sortBy = options.sortBy[0]
      if (sortBy) {
        if (options.sortDesc[0]) sort[`${sortBy}`] = -1
        else sort[`${sortBy}`] = 1
      }

      return { page, limit, sort }
    },
    setTablePaginatedResponse(response) {
      this.items = response.data.docs
      this.totalItems = response.data.totalDocs
    },
  },
}
